import { combineReducers } from 'redux';

const content = (state = {}, action) => {
  switch (action.type) {
    case 'SET_TERMS':
      return action.terms;
    default:
      return state;
  }
};

export default combineReducers({
  content,
});

export const getTermsContent = (state) => state.content;
